module.exports = __webpack_public_path__ + "img/suva-logo.0c3c9caf.png";